
    export enum EnumMerchStatus {
			Allowed = 0,
			Certified = 1,
			Pending = 2,
			NonOU = 3,
			NotApplicable = 4,
			Rejected = 5,
			Special = 6,
			Terminated = 7,
			WebApp = 8,
			Withdrawn = 9,
			xInProcess = 10,
			Current = 11,
			Expired = 12,
			IllegalOU = 13,
			Inactive = 14,
			Kosher = 15,
			N = 16,
			NotDetermined = 17,
			NOTKOSHER = 18,
			Closed = 19,
			SubmissionError = 20,
			New = 21,
			RemovedFromScheduleB = 22,
			Combined = 23,
			ItemNotFound = 24,
			Open = 25,
			Transferred = 26,
    }